import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { throttle } from 'throttle-debounce';

import { IOffersFeedProps } from '../../../../../containers/OfferHistory/types';
import { NarrowOffersFeed } from '../NarrowOffersFeed';
import { WideOffersFeed } from '../WideOffersFeed';

/** Точка перехода с широких строк офферов на узкие */
const SMALL_WIDTH_THRESHOLD = 730;

/** Выполняет роль переключателя с широкой ленты на узкую в зав-ти от доступной ширины блока */
export const OffersFeed: React.FC<IOffersFeedProps> = ({ feedViewState, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [isNarrow, setIsNarrow] = feedViewState;

  const ro = React.useMemo(
    () =>
      new ResizeObserver(
        throttle(200, entries => {
          setIsNarrow(entries[0].contentRect.width < SMALL_WIDTH_THRESHOLD);
        }),
      ),
    [setIsNarrow],
  );

  React.useEffect(() => {
    ro.observe(ref.current as HTMLDivElement);

    return () => ro.disconnect();
  }, [ro]);

  const FeedComponent = isNarrow ? NarrowOffersFeed : WideOffersFeed;

  return (
    <div ref={ref} style={{ height: '100%' }}>
      <FeedComponent {...props} />
    </div>
  );
};
